import { FBaseService } from '@kasasa/fbase-components/lib';
import { Store } from 'vuex';

export default class KrpTechopsAdminResource extends FBaseService {
  constructor(store: Store<Record<string, unknown>> | null = null) {
    super();

    this.apiClient.interceptors.request.use((request) => {
      if (store) {
        store.commit('authAccessed');
      }
      return request;
    }, error => Promise.reject(error));
  }
}
